import {
  Table,
  TableActionBarRow,
  ValueOrFallback,
} from "melco-ui";
import { useTranslation } from "react-i18next";

import { LicencesListFilter } from "./LicensesListFilter";
import { useLicences } from "../../hooks/licenses/useLicences";
import { useState } from "react";
import { GenerateLicenseDrawer } from "./drawer/generate/GenerateLicenseDrawer";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { TableCellLink } from "../table/TableCellLink";

type LicensesListPropTypes = {
  openGenerateLicenseDrawer: boolean;
  setOpenGenrateLicenseDrawerFunction: (v: boolean) => void
}

const DETAIL_VIEW_PATH = "/licenses/softwarelicenses"
export const LicensesList: React.FC<LicensesListPropTypes> = ({ openGenerateLicenseDrawer, setOpenGenrateLicenseDrawerFunction }) => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    filtersChange,
    refetch
  } = useLicences();
  const { t } = useTranslation();
  const { roles } = useRolesContext();

  const [batchNumberForNewGeneratedLicense, setBatchNumberForNewGeneratedLicense] = useState('');

  const columns = [
    {
      title: t("licenses.basic.table.column.serial_number.title"),
      key: "serial_number",
      dataIndex: "serial_number",
      sorter: true,
      width: 80,
      render: (_: string, item: any) => (
        <ValueOrFallback
          value={item.serial_number}
          render={(value) => (
            <TableCellLink to={[DETAIL_VIEW_PATH, item.serial_number].join("/")}>
              {value}
            </TableCellLink>
          )}
          fallback={t("global.fallback.empty")}
        />
      )
    },
    {
      title: t("licenses.basic.table.column.product.title"),
      key: "product_name",
      dataIndex: "product_name",
      sorter: true,
      width: 30,
    },
    {
      title: t("licenses.basic.table.column.version.title"),
      key: "version_number",
      dataIndex: "version_number",
      sorter: true,
      width: 30,
    },
    {
      title: t("licenses.basic.table.column.module.title"),
      key: "subscription_code",
      dataIndex: "subscription_code",
      sorter: true,
      width: 30,
    },
    {
      title: t("licenses.basic.table.column.refferal.title"),
      key: "referral_code",
      dataIndex: "referral_code",
      sorter: true,
      width: 30,

    },
    {
      title: t("licenses.basic.table.column.batch.title"),
      key: "batch",
      dataIndex: "batch",
      sorter: true,
      width: 30,
    },
    {
      title: t("licenses.basic.table.column.status.title"),
      key: "type",
      //  dataIndex: "serial_number",
      sorter: true,
      width: 30,
      render: (rowObj: any) => (
        // <div > {roles.VIRTUAL_SECURITY_CANCEL && !rowObj.cancelled &&
        //   <Button
        //     icon={<StopIcon />}
        //     type="primary"

        //     onClick={() => {
        //       setLicenseProductCode(rowObj.product_code);
        //       setDrawerOpen(true)
        //       setLicenseSerialNumberToCancel(rowObj.serial_number);
        //     }}
        //   >
        //     {t("licenses.basic.actions.cancel.button")}
        //   </Button>
        // }
        // </div>
        <>
          {
            // <ActivatedStatus activatedStatus={rowObj.type} />
            t(`licenses.basic.status_type.${rowObj.type}` as any)
          }
        </>
      ),

    },
  ];

  const setDrawerAction = (action: boolean) => {
    setOpenGenrateLicenseDrawerFunction(action);
    refetch();
  }

  const onGenerateLicenseCallbackFn = (obj: any) => {

    setBatchNumberForNewGeneratedLicense(obj?.list[0].batch ?? '')
  }

  return (
    <>

      <TableActionBarRow>

        {
          <LicencesListFilter
            onFiltersChange={filtersChange}
            batchNumberForNewGeneratedLicense={batchNumberForNewGeneratedLicense} />}

      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="serial_number"
        // rowSelection={rowSelection}
        // onRow={onRow}
        noDataMessage={t("licenses.basic.no_license_message")}
        errorComponent={errorComponent}
      //scroll={{ x: 1700 }}
      />


      {roles.VIRTUAL_SECURITY_GENERATE && <GenerateLicenseDrawer
        isDrawerOpen={openGenerateLicenseDrawer}
        setDrawerOpen={setDrawerAction}
        onGenerateLicenseCallBackFn={onGenerateLicenseCallbackFn}
      />}
    </>
  );
};
